import React, { Component } from 'react';
import { Switch, Route, BrowserRouter as Router, Redirect } from 'react-router-dom';

import withRoot from './style';
import MainLayout from './MainLayout';
import DialogDemo from './DialogDemo';

import { components as dashboardComponents } from './components/dashboard/index';
import { components as loginComponents } from './components/login';
import { components as tagManagementComponents } from './components/tag-mangement';
import { components as myLibraryComponents } from './components/mylibrary';
import { components as CreateCourseComponents } from './components/course';
import { components as TestTemplateComponents } from './components/test-template';
import { components as UserManagementComponents } from './components/user-management';
import { components as UserProfileComponents } from './components/user-profile';
import { components as GoalManagementComponents } from './components/goal-management';
import ReportsContainer from './components/reports/container/ReportsContainer';
import { components as CourseMangementComponents } from './components/course-Management';
import { MyPATSnackbar, MyPATSnackbarV2, MyPATGlobalLoader } from './components/common';

import { components as aclComponents } from './components/acl';
import ClientComponent from './components/client/ClientComponent';
import UserComponent from './components/client/UserComponent';
import RoleComponent from './components/client/RoleComponent';
import UserListComponent from './components/client/UserListComponent';
import { components as ClientTabComponents } from './components/userManagement';
import { components as ContentRequestComponents } from './components/content-request';
import UserManagement from './components/userManagement/containers/UserManagement';
import LicenseExpiredDialog from './components/common/LicenseExpiredDialog';
import MyPATAccessDenied from './components/common/MyPATAccessDenied';
import { CardData } from './components/content-request/containers/CardData';
import AfterAssignment from './components/content-request/components/AfterAssignment';
import EditCreateOwner from './components/content-request/components/EditCreateOwner';
import CourseManagementContainer from './components/course-Management/containers/CourseManagementContainer';
import TestSeriesCourseContainer from './components/course-Management/containers/TestSeriesCourseContainer';
import CreateTestSeries from './components/course-Management/components/CreateTestSeries';
import CoursePlanPreview from './components/course-Management/components/coursePlan/courseListing/components/CoursePlanPreview/CoursePlanPreview';
import CreateCoursePlan from './components/course-Management/components/coursePlan/CreateCoursePlan';
import PreviewLandingPage from './components/course-Management/components/coursePlan/courseListing/components/CoursePlanPreview/PreviewLandingPage';
import LoginV2 from './components/login/containers/LoginV2';
import LoginWithPassword from './components/login/components/LoginWithPassword';
import LoginWithOTP from './components/login/components/LoginWithOTP';
import ForgotPasswordWithOTP from './components/login/components/ForgotPasswordWithOTP';
import SetPassword from './components/login/components/SetPassword';
import terms from './components/footer/components/terms';
import privacy from './components/footer/components/privacy';
import disclaimer from './components/footer/components/disclaimer';
import copyright from './components/footer/components/copyright';
import AddSyllabus from './components/course-Management/components/AddSyllabus';
import { BULK_REPORT_DOWNLOAD_URL } from './components/course-Management/Constants/constants';
import BulkReportOperation from './components/course-Management/components/BulkReportOperation';
import HistoryDetail from './components/course-Management/components/coursePlan/courseListing/components/CoursePlanPreview/HistoryDetail';
import PopUP from './components/common/PopUP';
import SendNotification from './components/mylibrary/containers/SendNotification';
import ReportsMenu from './components/reports/container/ReportsMenu';

const {
  ClientTab,
  AddNewClient,
  EditClientDialog,
  AddNewRole,
  AddNewUser,
  EditRoleDialog,
  EditUserDialog,
} = ClientTabComponents;
const {
  ContentRequestContainer,
  ContentRequestCreateContainer,
  ContentRequestDetail,
  ContentReceivedRequestLandingContainer,
} = ContentRequestComponents;
const { Dashboard } = dashboardComponents;
const { Login, ForgotPasswordContainer, ResetPasswordContainer } = loginComponents;
const { TagManagementContainer } = tagManagementComponents;
const { MyLibraryHome, ContentPreview, ContentCreate } = myLibraryComponents;
const {
  CreateCourse,
  ArchivedCourse,
  AdvanceSettingMilestone,
  CourseDetail,
  MilestoneDetails,
  CourseTemplate,
} = CreateCourseComponents;
const { TestTemplate } = TestTemplateComponents;
const { UserManagementContainer } = UserManagementComponents;
const { UserProfileContainer } = UserProfileComponents;
const { PrivateRoute } = aclComponents;
const { CoursePlanLandingPage, CreateNewCourse, ComboCoursePopup, CreateNewComboCourse } = CourseMangementComponents;
const {
  GoalManagementContainer,
  EditGoalManagementContainer,
  DeletedGoalContainer,
  SubjectMappingContainer,
  ChapterMappingContainer,
  ConceptMappingContainer,
  SubSubjectMappingContainer,
} = GoalManagementComponents;

interface MyPATAppProps {}

interface MyPATAppStates {}

class MyPATApp extends Component<MyPATAppProps, MyPATAppStates> {
  constructor(props: MyPATAppProps) {
    super(props);
  }
  render() {
    return (
      <>
        <Router>
          <Switch>
            <Redirect exact from='/' to='login' />
            <PrivateRoute exact path='/dialogDemo' component={DialogDemo} />
            <Route exact path='/login' component={Login} />
            <Route exact path='/login-with-password' component={Login} />
            <Route exact path='/login-with-otp' component={Login} />
            <Route exact path='/forgot-with-otp' component={Login} />
            <Route exact path='/set-password' component={SetPassword} />
            <Route exact path='/sendNotification/:qId/:questionCode/:questionType/:questionId/:questionData' component={SendNotification} />
            <Route exact path='/sendNotification/:qId/:questionCode/:questionType/:questionId/:reviewerId/:questionData' component={SendNotification} />
            <Route exact path='/forgot-password' component={ForgotPasswordContainer} />
            <Route exact path='/reset/:hash' component={ResetPasswordContainer} />
            <Route exact path='/terms-of-use' component={terms} />
            <Route exact path='/privacy-policy' component={privacy} />
            <Route exact path='/disclaimer' component={disclaimer} />
            <Route exact path='/copyright' component={copyright} />
            <PrivateRoute exact path='/tag-management' component={TagManagementContainer} />
            <PrivateRoute exact path='/test-template' component={TestTemplate} />
            <PrivateRoute exact path='/content/create/:type/:subType' component={ContentCreate} />
            <PrivateRoute exact path='/content/edit/:type/:subType/:contentId' component={ContentCreate} />
            <PrivateRoute exact path='/content/edit/:type/:subType/:contentId/:requestId' component={ContentCreate} />
            <MainLayout>
              <PrivateRoute exact path='/client' component={ClientComponent} />
              <PrivateRoute exact path='/contentRequest/owner-task/:contentRequestId/:role' component={CardData} />
              <PrivateRoute exact path='/user' component={UserComponent} />
              <PrivateRoute exact path='/role' component={RoleComponent} />
              <PrivateRoute
                exact
                path='/course-Management/create-standard-course/:id'
                component={CoursePlanLandingPage}
              />
              <PrivateRoute exact path='/course-Management/create-standard-course' component={CreateNewCourse} />
              <PrivateRoute exact path='/course-Management/create-combo-course' component={CreateNewComboCourse} />
              <PrivateRoute
                exact
                path='/course-Management/create-combo-course/:id/:type?'
                component={CoursePlanLandingPage}
              />
              <PrivateRoute exact path='/course-Management/create-testSeries' component={CreateTestSeries} />
              <PrivateRoute exact path='/course-Management/testSeries/:id' component={TestSeriesCourseContainer} />
              <PrivateRoute
                exact
                path='/course-Management/testSeries/:id/preview'
                component={TestSeriesCourseContainer}
              />
              <PrivateRoute
                exact
                path='/course-Management/testSeries/edit/published/:id'
                component={TestSeriesCourseContainer}
              />
              <PrivateRoute exact path='/course-Management/addSyllabus' component={AddSyllabus} />
              <PrivateRoute exact path={BULK_REPORT_DOWNLOAD_URL} component={BulkReportOperation} />
              <PrivateRoute exact path='/course-Management/coursePlanPreview/:id' component={PreviewLandingPage} />
              <PrivateRoute exact path='/course-Management/coursePlanPreview/history/:id' component={HistoryDetail} />
              <PrivateRoute exact path='/user-list' component={UserListComponent} />
              <PrivateRoute exact path='/dashboard' component={Dashboard} />
              <PrivateRoute exact path='/mylibrary' component={MyLibraryHome} />
              <PrivateRoute exact path='/accessDenied' component={MyPATAccessDenied} />
              <PrivateRoute exact path='/contentRequest' component={ContentRequestContainer} />
              <PrivateRoute
                exact
                path='/contentRequest/create/:requestContentType'
                component={ContentRequestCreateContainer}
              />
              <PrivateRoute exact path='/contentRequest/:requestId' component={AfterAssignment} />
              <PrivateRoute
                exact
                path='/contentRequest/:requestContentType/:requestId/edit'
                component={EditCreateOwner}
              />

              <PrivateRoute
                exact
                path='/contentRequest/edit/:requestContentType/:requestId'
                component={ContentRequestCreateContainer}
              />
              <PrivateRoute
                exact
                path='/contentRequest/received/:requestId/:authorType'
                component={ContentReceivedRequestLandingContainer}
              />
              <PrivateRoute exact path='/content/preview/:id/:requestId?' component={ContentPreview} />
              <PrivateRoute exact path='/course/milestoneDetail/:m_id/content/preview/:id' component={ContentPreview} />
              <PrivateRoute exact path='/user-management' component={UserManagementContainer} />
              <PrivateRoute exact path='/userManagement' component={UserManagement} />
              <PrivateRoute exact path='/userManagement/addClient' component={AddNewClient} />
              <PrivateRoute exact path='/userManagement/addRole' component={AddNewRole} />
              <PrivateRoute
                exact
                path='/userManagement/addUser'
                component={AddNewUser}
                moduleName='user'
                type='create'
              />
              <PrivateRoute exact path='/userManagement/editClient/:clientId' component={EditClientDialog} />
              <PrivateRoute exact path='/userManagement/editRole/:roleId' component={EditRoleDialog} />
              <PrivateRoute
                exact
                path='/userManagement/editUser/:userId'
                component={EditUserDialog}
                moduleName='user'
                type='edit'
              />
              <PrivateRoute exact path='/user-profile' component={UserProfileContainer} />
              <PrivateRoute exact path='/goal-management' component={GoalManagementContainer} />
              <PrivateRoute exact path='/reports' component={ReportsMenu} />
              <PrivateRoute exact path='/goal-management/edit/:id' component={EditGoalManagementContainer} />
              <PrivateRoute exact path='/goal-management/deleted' component={DeletedGoalContainer} />
              <PrivateRoute
                exact
                path='/subject-mapping/:parentId/:courseId/:classId/:groupId'
                component={SubjectMappingContainer}
              />
              <PrivateRoute
                exact
                path='/sub-subject-mapping/:parentId/:courseId/:classId/:subjectId/:groupId'
                component={SubSubjectMappingContainer}
              />
              <PrivateRoute
                exact
                path='/chapter-mapping/:parentId/:courseId/:classId/:subSubjectId/:groupId'
                component={ChapterMappingContainer}
              />
              <PrivateRoute
                exact
                path='/concept-mapping/:parentId/:courseId/:classId/:chapterId/:groupId'
                component={ConceptMappingContainer}
              />
              <PrivateRoute exact path='/course-Management' component={CourseManagementContainer} />
              <PrivateRoute exact path='/archive-course' component={ArchivedCourse} />
              <PrivateRoute exact path='/course/detail/:id' component={CourseDetail} />
              <PrivateRoute exact path='/course/milestoneDetail/:courseID/:milestoneId' component={MilestoneDetails} />
              <PrivateRoute exact path='/course/advancesetting/:id' component={AdvanceSettingMilestone} />
              <PrivateRoute exact path='/course/coursetemplate' component={CourseTemplate} />
              <PrivateRoute exact path='/course/testdialogue' component={ComboCoursePopup} />

              <LicenseExpiredDialog />
            </MainLayout>
          </Switch>
        </Router>
        <MyPATSnackbar />
        <MyPATSnackbarV2 />
        <MyPATGlobalLoader />
        <PopUP />
      </>
    );
  }
}

// @ts-ignore
export default withRoot(MyPATApp);
